<template>
    <div class="cart-page__body col-9 col-md-12">
        <div class="step-block step-block--finish">

            <steps-panel></steps-panel>

            <!--<div class="step-block__head">
                <div class="step-block__title">Заказ № 504</div>
            </div>-->
            <div class="step-block__sub-title">Информация о заказе</div>

            <div class="step-block__info row">
                <div class="step-block__info__label col-4 col-xs-12">Дата оформления</div>
                <div class="step-block__info__value col-8 col-xs-12">{{ dateNow }}</div>

                <div class="step-block__info__label col-4 col-xs-12">Сумма</div>
                <div class="step-block__info__value col-8 col-xs-12" v-html="orderSummary.totalPrice.formatted"></div>

                <div class="step-block__info__label col-4 col-xs-12">Способ оплаты</div>
                <div class="step-block__info__value col-8 col-xs-12">{{ paysystemName }}</div>

                <div class="step-block__info__label col-4 col-xs-12">Способ доставки</div>
                <div class="step-block__info__value col-8 col-xs-12">{{ deliveryName }}</div>

                <div class="step-block__info__label col-4 col-xs-12">Адрес доставки</div>
                <div class="step-block__info__value col-8 col-xs-12">{{ fullDeliveryAddress }}</div>

                <div class="step-block__info__label col-4 col-xs-12">Получатель</div>
                <div class="step-block__info__value col-8 col-xs-12">{{ model.surName }} {{ model.name }}</div>

                <div class="step-block__info__label col-4 col-xs-12">E-mail</div>
                <div class="step-block__info__value col-8 col-xs-12">{{ model.email }}</div>

                <div class="step-block__info__label col-4 col-xs-12">Телефон</div>
                <div class="step-block__info__value col-8 col-xs-12">{{ model.phone }}</div>

                <div class="step-block__info__label col-4 col-xs-12">Комментарий</div>
                <div class="step-block__info__value col-8 col-xs-12">{{ model.comment }}</div>
            </div>

            <div class="step-block__finish-cart">
                <div class="step-block__sub-title step-block__sub-title--no-border">Состав заказа</div>

                <div class="finish-cart">
                    <div class="finish-cart__head">
                        <div class="finish-cart__head__item finish-cart__head__item--name">Наименование</div>
                        <div class="finish-cart__head__item finish-cart__head__item--count">Кол-во</div>
                        <div class="finish-cart__head__item finish-cart__head__item--price">Цена</div>
                    </div>
                    <div class="finish-cart__row" v-for="item in orderSummary.basket.items" :key="item.id">
                        <div class="finish-cart__item finish-cart__item--name">{{ item.name }}</div>
                        <div class="finish-cart__item finish-cart__item--count">{{ item.quantity }}</div>
                        <div class="finish-cart__item finish-cart__item--price" v-html="item.priceFormatted"></div>
                    </div>
                </div>
            </div>

            <div class="input-row__error" v-for="(error, fieldName) in errors" :key="fieldName">{{ error }}</div>
	    
            <div class="step-block__buttons">
                <a @click.prevent="saveOrder(model)" href="#" class="btn btn--black btn--next btn--md">
                    <span>Оформить заказ</span>
                    <svg class="icon btn__icon">
                        <use xlink:href="/local/templates/reloft2020/asset/images/sprite.svg#btn-arrow"></use>
                    </svg>
                </a>
            </div>            
        </div>
    </div>
</template>

<script>
    import StepsPanel from "@/components/Checkout/StepsPanel";
    import {mapState, mapActions} from 'vuex';

    export default {
        name: 'StepFinal',
        components: {
            StepsPanel,
        },
        methods: {
            ...mapActions('StoreCheckout', ['saveOrder'])
        },
        computed: {
            ...mapState('StoreCheckout', ['model', 'orderSummary', 'errors']),
            availableDeliveries: function () {
                return this.orderSummary.availableDeliveries ?? [];
            },
            availablePaySystems: function () {
                return this.orderSummary.availablePaySystems ?? [];
            },
            fullDeliveryAddress: function () {
                const model = this.model;
                let fullDeliveryAddress =  `${model.locationCode}, ${model.street} ${model.house}`;
                if (model.building.length > 0) {
                    fullDeliveryAddress += `, к. ${model.building}`;
                }

                if (model.apartments.length > 0) {
                    fullDeliveryAddress += `, кв. ${model.apartments}`;
                }

                return fullDeliveryAddress;
            },
            deliveryName: function () {
                if (this.model.deliveryId.length) {
                    let delivery = this.availableDeliveries.find(delivery => parseInt(delivery.ID) === parseInt(this.model.deliveryId));
                    return delivery.NAME;
                }

                return '-';
            },
            paysystemName: function () {
                if (this.model.paysystemId.length) {
                    let paysystem = this.availablePaySystems.find(paysystem => parseInt(paysystem.ID) === parseInt(this.model.paysystemId));
                    return paysystem.NAME;
                }

                return '-';
            },
            dateNow: function () {
                const now = new Date()

                function formatDate(date) {
                    let dd = date.getDate();
                    if (dd < 10) dd = '0' + dd;

                    let mm = date.getMonth() + 1;
                    if (mm < 10) mm = '0' + mm;

                    let yy = date.getFullYear() % 100;
                    if (yy < 10) yy = '0' + yy;

                    return dd + '.' + mm + '.' + yy;
                }

                return `${formatDate(now)} ${now.getHours()}:${now.getMinutes()}`;
            }
        }
    }
</script>